import React from "react";

import { styled } from "../../stitches.config";
import { body, bodyStrong } from "../commonStyles/Fonts";
import { useStores } from "../../helpers";
import { useAuth } from "../../context/AuthContext";

const ZenBox = () => {
  const [{ user }] = useAuth();
  const { UIStore } = useStores();

  const handleZenToggle = (e: any) => {
    e.preventDefault();
    UIStore.setShowLoginModal(true);
  }

  return (user && user.valid
    ? null
    : <a href="#" onClick={handleZenToggle}>
      <Wrapper>
        <p className={bodyStrong()}>Odkryj Twoje na:Temat</p>
        <p className={body()}>
          Oglądaj treści bez reklam. Pozwól sobie na pełne skupienie na treści
          artykułu.
        </p>
        <span className={body()}>4,99zł / miesięcznie</span>
        <span className={body()}>Wypróbuj →</span>
      </Wrapper>
    </a>
  );
};

const Wrapper = styled("div", {
  marginTop: "24px",
  marginBottom: "24px",
  width: "192px",
  padding: "16px",
  background: "$grayscale100",
  color: "$grayscale0",
  textDecoration: "none",
  "@bp4": {
    marginBottom: "0px",
  },
  p: {
    margin: 0,
    "&:nth-child(2)": {
      margin: "6px 0 14px 0",
    },
  },
  span: {
    color: "$natematPrimary",
    display: "block",
  },
  a: {
    textDecoration: "none",
  },
});

export default ZenBox;
